import { render, staticRenderFns } from "./ControlBar.vue?vue&type=template&id=de24fa12&scoped=true&"
import script from "./ControlBar.vue?vue&type=script&lang=js&"
export * from "./ControlBar.vue?vue&type=script&lang=js&"
import style0 from "./ControlBar.vue?vue&type=style&index=0&id=de24fa12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de24fa12",
  null
  
)

export default component.exports